import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { epicsErrorHandler } from '../../../epics'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(DATA_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter.getScannerDetail(action.payload.elem).pipe(
        map((response) => fetchDataSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
        takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(fetchDataEpic)
